// type-coverage:ignore-next-line
import { inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class BodyStylesService {
    private readonly document = inject(DOCUMENT);
    private readonly platformId = inject<string>(PLATFORM_ID);
    public setOverflowBody(hidden: boolean): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        const body = this.document.querySelector('body');
        if (!body) {
            return;
        }
        body.style.overflowY = hidden ? 'hidden' : 'overlay';
    }
}
